import { parse } from "./routes"

async function main() {
  const { pathname } = location

  const route = parse(pathname)

  if (!route) {
    return
  }

  switch (route.kind) {
    case "CapabilityForm": {
      const { main } = await import(
        /* webpackChunkName: "CapabilityForm" */ "./pages/CapabilityForm"
      )
      return main()
    }
    case "DestroyAdminSsoConfigurationForm": {
      const { main } = await import(
        /* webpackChunkName: "DestroyAdminSsoConfigurationForm" */ "./pages/DestroyAdminSsoConfigurationForm"
      )
      return main()
    }
    case "EditAdminSsoConfigurationForm":
    case "NewAdminSsoConfirmationForm": {
      const { main } = await import(
        /* webpackChunkName: "AdminSsoConfigurationForm" */ "./pages/AdminSsoConfigurationForm"
      )
      return main()
    }
    case "CustomActionDependents": {
      const { main } = await import(
        /* webpackChunkName: "CustomActionDependents" */ "./pages/CustomActionDependents"
      )
      return main()
    }
    case "EditCustomActionForm":
    case "NewCustomActionForm": {
      const { main } = await import(
        /* webpackChunkName: "CustomActionForm" */ "./pages/CustomActionForm"
      )
      return main()
    }
    case "ScenarioEditor": {
      const { main } = await import(
        /* webpackChunkName: "ScenarioEditor" */ "./pages/ScenarioEditor"
      )
      return main({
        kind: "Scenario",
        projectId: route.projectId,
      })
    }
    case "StepGroupEditor": {
      const { main } = await import(
        /* webpackChunkName: "ScenarioEditor" */ "./pages/ScenarioEditor"
      )
      return main({
        kind: "StepGroup",
        projectId: route.projectId,
      })
    }
    case "ScenarioHistory": {
      const { main } = await import(
        /* webpackChunkName: "ScenarioEditor" */ "./pages/ScenarioEditor"
      )
      return main({
        kind: "ScenarioHistory",
        projectId: route.projectId,
      })
    }
    case "ScenarioList": {
      const { main } = await import(
        /* webpackChunkName: "ScenarioList" */ "./pages/ScenarioList"
      )
      return main(route)
    }
    case "UserSettings": {
      const { main } = await import(
        /* webpackChunkName: "Settings" */ "./pages/Settings"
      )
      return main()
    }
    case "ProjectSettingsList": {
      const { main } = await import(
        /* webpackChunkName: "Settings" */ "./pages/Settings"
      )
      return main()
    }
    case "StepGroupList": {
      const { main } = await import(
        /* webpackChunkName: "StepGroupList" */ "./pages/StepGroupList"
      )
      return main(route)
    }
    case "TestPlanCapabilityResult": {
      const { main } = await import(
        /* webpackChunkName: "TestPlanCapabilityResult" */ "./pages/TestPlanCapabilityResult"
      )
      return main({
        projectId: String(route.projectId),
        resultId: String(route.resultId),
        capabilityId: String(route.capabilityId),
      })
    }
    case "TestCaseResults": {
      const { main } = await import(
        /* webpackChunkName: "TestCaseResults" */ "./pages/TestCaseResults"
      )
      return main(route)
    }
    case "TestPlan": {
      const { main } = await import(
        /* webpackChunkName: "TestPlan" */ "./pages/TestPlan"
      )
      return main()
    }
    case "TestPlanList": {
      const { main } = await import(
        /* webpackChunkName: "TestPlanList" */ "./pages/TestPlanList"
      )
      return main({
        projectId: String(route.projectId),
      })
    }
    case "TestPlanScenarioList": {
      const { main } = await import(
        /* webpackChunkName: "TestPlanScenarioList" */ "./pages/TestPlanScenarioList"
      )
      return main()
    }
    case "GotthardKeyNewForm":
    case "GotthardKeyEditForm": {
      const { main } = await import(
        /* webpackChunkName: "GotthardKeyForm" */ "./pages/GotthardKeyForm"
      )
      return main()
    }
    case "EditAdminCustomActionForm":
    case "NewAdminCustomActionForm": {
      const { main } = await import(
        /* webpackChunkName: "AdminCustomActionForm" */ "./pages/AdminCustomActionForm"
      )
      return main()
    }
    case "AdminCustomActionReader": {
      const { main } = await import(
        /* webpackChunkName: "AdminCustomActionReader" */ "./pages/AdminCustomActionReader"
      )
      return main()
    }
    case "AdminScenarioTransfers": {
      const { main } = await import(
        /* webpackChunkName: "AdminScenarioTransfers" */ "./pages/AdminScenarioTransfers"
      )
      return main()
    }

    case "AdminPartnerList": {
      const { main } = await import(
        /* webpackChunkName: "AdminPartnerList" */ "./pages/AdminPartnerList"
      )
      return main()
    }

    case "AdminPartnerDetail": {
      const { main } = await import(
        /* webpackChunkName: "AdminPartnerDetail" */ "./pages/AdminPartnerDetail"
      )
      return main()
    }

    // Hide the PartnerScenarioTransfers for now
    // case "PartnerScenarioTransfers": {
    //   const { main } = await import(
    //     /* webpackChunkName: "PartnerScenarioTransfers" */ "./pages/AdminScenarioTransfers"
    //   )
    //   return main()
    // }

    case "PartnerOrganizations": {
      const { main } = await import(
        /* webpackChunkName: "PartnerOrganizations" */ "./pages/PartnerOrganizations"
      )
      return main()
    }
    case "PartnerProjects": {
      const { main } = await import(
        /* webpackChunkName: "PartnerProjects" */ "./pages/PartnerProjects"
      )
      return main()
    }
    case "TriggerEditor": {
      const { main } = await import(
        /* webpackChunkName: "TriggerEditor" */ "./pages/TriggerEditor"
      )
      return main()
    }
    case "TrialForm": {
      const { main } = await import(
        /* webpackChunkName: "TrialForm" */ "./pages/TrialForm"
      )
      return main()
    }
    case "TrialFormSettings": {
      const { main } = await import(
        /* webpackChunkName: "TrialFormSettings" */ "./pages/TrialFormSettings"
      )
      return main()
    }
    case "TrialFormUsage": {
      const { main } = await import(
        /* webpackChunkName: "TrialFormUsage" */ "./pages/TrialFormUsage"
      )
      return main()
    }
    case "TestPlanResultList": {
      const { main } = await import(
        /* webpackChunkName: "TestPlanResultList" */ "./pages/TestPlanResultList"
      )
      return main({
        kind: "TestPlanResultList",
        projectId: String(route.projectId),
      })
    }
    case "Report": {
      const { main } = await import(
        /* webpackChunkName: "Report" */ "./pages/Report"
      )
      return main()
    }
    case "Project": {
      const { main } = await import(
        /* webpackChunkName: "TestPlanResultList" */ "./pages/TestPlanResultList"
      )
      return main({
        kind: "Project",
        projectId: String(route.projectId),
      })
    }
    case "DomSnapshot": {
      const { main } = await import(
        /* webpackChunkName: "DomSnapshot" */ "./pages/DomSnapshot"
      )
      return main()
    }
    case "Graphiql": {
      const { main } = await import(
        /* webpackChunkName: "Graphiql" */ "./pages/Graphiql"
      )
      return main()
    }
  }
}

main().catch((err) => {
  // FIXME: how to handle error?
  console.error(err)
})
